import { makeStyles } from "@material-ui/core";

export const SelectStyle = makeStyles((theme) => ({
  wrapper: {
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    color: 'white',
    fontSize: '.65rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center'
  },
  provinceList: {
    top: 46,
    width: 140,
    right: 35,
    height: 260,
    padding: '0 5px',
    position: 'absolute',
    background: '#283B52',
    overflowY: 'auto',
    alignItems: 'center',
    borderRadius: '0 0 10px 10px',
    flexDirection: 'column',
    justifyContent: 'center',
    scrollbarColor: `#000 #C2D2E4`,
    scrollbarWidth: 'thin',

    '&::-webkit-scrollbar': {
      width: 5
    },

    '&::-webkit-scrollbar-track': {
      boxShadow: `inset 0 0 5px gray`,
      borderRadius: 10,
    },

    '&::-webkit-scrollbar-thumb': {
      background: "#C2D2E4",
      borderRadius: 10,
    },

    '&::-webkit-scrollbar-thumb:hover': {
      background: "#C2D2E4",
    }
  },
  item: {
    fontSize: '.8rem',
    color: 'white',
    cursor: 'pointer',
    textAlign: 'right',
    borderBottom: `1px solid #000055`,
    width: '100%',
    padding: '8px 3px',

    "&:last-child": {
      borderBottom: 'none',
    },

    "&:hover": {
      color: "#00D4FF",
    }
  }
}));